import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import Home from './components/Home';
import RandomVoucherWithLogin from './components/RandomVoucherWithLogin';

function App() {

  return (
    <Router>
      <div className="min-h-screen p-8">
        <div className="container mx-auto">
          {/* <Header parentCategories={parentCategories} /> */}
          {/* <ThemeToggle darkMode={darkMode} setDarkMode={setDarkMode} /> */}
          <Routes>
            <Route
              path="/"
              exact
              element={
                <Home />
              }
            />
            <Route
              path="/randomvoucher/:collectionid"
              element={
                <RandomVoucherWithLogin />
              }
            />

          </Routes>
        </div>
      </div>
    </Router>
  );
}

export default App;